import { Typography, Button, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';


export function SortingButtons({ sortConfig, sortRows }) {

    const theme = useTheme();
    let buttonStyling = {
        border: theme.palette.sortButton.border,
        backgroundColor: theme.palette.sortButton.background,
        textColor: theme.palette.sortButton.text,
        selectedTextColor: theme.palette.sortButton.selectedText,
        selectedBackgroundColor: theme.palette.sortButton.selected,
        hoverColor: theme.palette.sortButton.hover,
        headerBackground: theme.palette.background.default,
        bottomBorder: theme.palette.sortButton.bottomBorder,
    }

    let buttonFormat = {
        borderRadius: '20px',
        textTransform: 'none',
        border: "none",
        '&:hover': {
            backgroundColor: buttonStyling.hoverColor,
        },
    }

    const isSelected = (f) => sortConfig.field === f && (sortConfig.direction === "asc" || sortConfig.direction === "desc");

    return (
        <Stack direction="row" spacing={1}>
            <Typography variant='h6' sx={{ borderRight: buttonStyling.border, paddingRight: '1em', paddingLeft: '1em', display: { xs: 'none', md: 'block' }, }}>
                Sort
            </Typography>
            <Button variant="outlined" sx={{
                ...buttonFormat,
                backgroundColor: isSelected('live') ? buttonStyling.selectedBackgroundColor : buttonStyling.backgroundColor,
                color: isSelected('live') ? buttonStyling.selectedTextColor : buttonStyling.textColor,
            }} onClick={() => sortRows('live')}>Live</Button>
            <Button variant="outlined" sx={{
                ...buttonFormat,
                backgroundColor: isSelected("call_sign") ? buttonStyling.selectedBackgroundColor : buttonStyling.backgroundColor,
                color: isSelected("call_sign") ? buttonStyling.selectedTextColor : buttonStyling.textColor,
            }} onClick={() => sortRows('call_sign')}>Call Sign</Button>
            <Button variant="outlined" sx={{
                ...buttonFormat,
                backgroundColor: isSelected('affiliation') ? buttonStyling.selectedBackgroundColor : buttonStyling.backgroundColor,
                color: isSelected('affiliation') ? buttonStyling.selectedTextColor : buttonStyling.textColor,
            }} onClick={() => sortRows('affiliation')}>Affiliate</Button>
            <Button variant="outlined" sx={{
                ...buttonFormat,
                backgroundColor: isSelected('market') ? buttonStyling.selectedBackgroundColor : buttonStyling.backgroundColor,
                color: isSelected('market') ? buttonStyling.selectedTextColor : buttonStyling.textColor,
            }} onClick={() => sortRows('market')}>Market</Button>
        </Stack>
    );
}